import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpService } from '../services/http.service';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PageTypeGuard implements CanActivate {

  constructor(
    private httpService: HttpService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const pageId = route.paramMap.get('id');
    
    if (!pageId) {
      console.error('PageTypeGuard: No se encontró pageId');
      this.router.navigate(['/']);
      return of(false);
    }

    console.log('PageTypeGuard: Evaluando página', pageId);

    return this.httpService.myGet(`${Environment.API_BASE_URL_V2}/api/empatica/v1/pages/${pageId}`).pipe(
      map((response: any) => {
        console.log('PageTypeGuard: Configuración de página cargada:', response);
        
        if (response && (response.is_chatbot || response.isChatbot)) {
          // Es una página de chatbot, redirigir con los datos
          console.log('PageTypeGuard: Redirigiendo al chatbot');
          this.router.navigate(['/chatbot'], {
            queryParams: { pageId: pageId },
            state: { pageData: response }
          });
          return false; // No activar la ruta actual
        } else {
          // Es una página genérica, permitir acceso
          console.log('PageTypeGuard: Permitiendo acceso a página genérica');
          return true;
        }
      }),
      catchError((error) => {
        console.error('PageTypeGuard: Error evaluando página:', error);
        // En caso de error, permitir acceso a página genérica como fallback
        console.log('PageTypeGuard: Error, permitiendo acceso a página genérica como fallback');
        return of(true);
      })
    );
  }
}
